import { render, staticRenderFns } from "./RuleWidget.vue?vue&type=template&id=20acc7a4"
import script from "./RuleWidget.vue?vue&type=script&lang=js"
export * from "./RuleWidget.vue?vue&type=script&lang=js"
import style0 from "./RuleWidget.vue?vue&type=style&index=0&id=20acc7a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports